export class MerchantBriefDto {
  id: number;
  name: string;
  businessName: string;
  currencyId: number;
}
